// src/components/rewards/RewardsBar.js
//
// The three step-5 buttons, side by side:
//   🗺️ Daily trail   (a red dot when today's step is waiting)
//   🎁 Gifts         (how many are waiting; always opens the gifts list)
//   📒 Stickers
// Put it on the student dashboard and in the subject-page toolbar.
// `compact` shows icons only.

import React, { useState } from "react";
import DailyTrail from "./DailyTrail";
import GiftsPopup from "./GiftsPopup";
import StickerAlbum from "./StickerAlbum";
import { useWallet } from "../../services/coinService";
import { trailStatus, useChests } from "../../services/rewardsService";
import "./rewards.css";

const RewardsBar = ({ compact = false, className = "" }) => {
  const wallet = useWallet();
  const { chests } = useChests();
  const [open, setOpen] = useState(""); // trail | gifts | album
  const canClaim = wallet.loaded && trailStatus(wallet.trail).canClaim;

  return (
    <span className={`sbl-rw-bar ${compact ? "is-compact" : ""} ${className}`}>
      <button type="button" className="sbl-rw-chip is-trail" onClick={() => setOpen("trail")} title="Daily treasure trail">
        <span aria-hidden="true">🗺️</span>
        {!compact && " Daily trail"}
        {canClaim && <i className="sbl-rw-dot" aria-label="ready" />}
      </button>
      <button type="button" className={`sbl-rw-chip is-chest ${chests.length ? "" : "is-empty"}`} onClick={() => setOpen("gifts")} title={chests.length ? `Open a gift (${chests.length} waiting)` : "My gifts"}>
        <span aria-hidden="true">🎁</span>
        {!compact && " Gifts"}
        {chests.length > 0 && <i className="sbl-rw-count">{chests.length}</i>}
      </button>
      <button type="button" className="sbl-rw-chip is-album" onClick={() => setOpen("album")} title="Sticker albums">
        <span aria-hidden="true">📒</span>
        {!compact && " Stickers"}
      </button>

      {open === "trail" && <DailyTrail onClose={() => setOpen("")} />}
      {open === "album" && <StickerAlbum onClose={() => setOpen("")} />}
      {open === "gifts" && <GiftsPopup onClose={() => setOpen("")} />}
    </span>
  );
};

export default RewardsBar;
